/**
 * Retour d'onglet pendant une phase chronometree.
 *
 * Le timer n'est jamais suspendu : le serveur fait autorite et la partie a
 * continue. Le bandeau ne fait qu'expliquer pourquoi le temps a saute, ce qui
 * evite au joueur de croire a un bug.
 */
import { useEffect, useState, type ReactElement } from 'react';
import { useT } from '../locales/useT.js';
import { useRoomStore } from '../store/roomStore.js';

const BANNER_MS = 4000;
/** En dessous, l'absence est trop courte pour meriter une explication. */
const MIN_AWAY_MS = 2500;

export function AwayBanner(): ReactElement | null {
  const t = useT();
  const phase = useRoomStore((state) => state.room?.phase ?? null);
  const [visible, setVisible] = useState(false);

  const timed = phase === 'DRAWING' || phase === 'GUESSING' || phase === 'REVEAL';

  useEffect(() => {
    if (!timed) return;

    let hiddenAt: number | null = null;
    let timer = 0;

    const onVisibility = (): void => {
      if (document.hidden) {
        hiddenAt = Date.now();
        return;
      }
      if (hiddenAt === null || Date.now() - hiddenAt < MIN_AWAY_MS) return;
      hiddenAt = null;
      setVisible(true);
      window.clearTimeout(timer);
      timer = window.setTimeout(() => setVisible(false), BANNER_MS);
    };

    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      window.clearTimeout(timer);
    };
  }, [timed]);

  if (!visible) return null;

  return (
    <div className="away-banner" role="status">
      <strong>{t('visibility.backTitle')}</strong>
      <span>{t('visibility.backBody')}</span>
    </div>
  );
}
